

import { useContext, useEffect, useReducer, useState } from 'react';
import { CurrentPContext, MasterContext, MobiOrNotContext, OrderContext, OrdStageContext } from '../ContextApi/context';
import ShopingCratFloat from './ShopingCratFloat';
import { BrowserRouter as Router, Switch, Route, Link, useParams, useRouteMatch } from "react-router-dom";
import { useHistory } from "react-router-dom";

import OrderFunctions from '../OrderSettings/OrderFunctions';
import ConnUrls from '../Connections/ConnectURL';
import MyDateTime from './MyDateTime';
import { DirectionsBike, FiberManualRecord } from '@mui/icons-material';
import myFunctions from '../myFunctions';
import useNotDelivering from './useNotDelivering';


const RestSmallBlock = (props) => {

    const [theItem, setItem] = useState(props.item);
    const [master] = useContext(MasterContext);
    const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext);
    const [timing, setTiming] = useState();
    const [priceing, setPriceing] = useState();
    const notDeliveringTxt = useNotDelivering();
    let shuffClosed = [];


    useEffect(() => {

    }, [])




    //chans = הפלט של resolveBusinessChannels.
    //הנקודה והטקסט מציגים chans.business (שעות הפתיחה), בעוד
    //הרצועה והמיון נגזרים מ-canOrderNow. לכן כרטיס יכול להיות
    //בעל נקודה ירוקה וגם ממוין אחרון עם רצועה שמסבירה למה
    const setOpenItem = (item, index, chans) => {

        let opHours = chans.business;
        let notGettinOrders = myFunctions.notGettinOrders(master, item, chans);
        let timing = (item.Delivery?.Time) ? item.Delivery.Time : (item.TakeAway?.Time) ? item.TakeAway.Time : 30;
        let timingChannel = (item.Delivery?.Time) ? "Deliver" : "Take";
        timing = myFunctions.checkForDeliverysDelay(master, timing, timingChannel);

        // Check if txtBuisKosher contains "כשר" or "כשרות", and remove them.
        // If after removal there's no other content, don't render the block.
        const kosherText = item.txtBuisKosher;

        return (
            <li key={index} className={"Hprest animate__animated pulseME"}>
                <Link to={{
                    pathname: `/restaurants/${item.pageUrlFix != null && item.pageUrlFix != "" ? item.pageUrlFix : item._id}`,
                    state: { waitImg: item.waitingImg }
                }}>
                    <div className={"imgWrap"}>
                        <div className={"imgDiv"} style={{ backgroundImage: `url("${ConnUrls.servMediasUrl}${item.buissMainImg}")` }} >

                            <div className={"botBlock"}>
                                {(notGettinOrders != "") ?
                                    <div data-nosnippet className={"imgWrapDivClose no-render"}>
                                        <span data-nosnippet className={"no-render"}>{notGettinOrders}</span>
                                    </div> : ""}
                                <div className={"width_96"}>

                                    <div className={"fullRow overflowHid dottedLine_2"}>
                                        <div className={`smBlockHead pgBigTxt bold onRight ${!mobiOrNot ? "big spacePadBig" : ""}`}>{item.buissName}</div>
                                        {kosherText !== "" &&
                                            <div className={"txtBuisKosher_Block onLeft"}>{kosherText}</div>
                                        }
                                    </div>
                                    <div className={"fullRow fullRowflex"}>
                                        <div className={"pgSmallTxt regular grayText"}>
                                            <p>{item.buissKitchType}</p>
                                        </div>
                                        <div className={"pgSmallTxt"}>
                                            <p className={"pgOpenCloseBlk mediumst"}>
                                                <span className={`specDot ${!opHours.openOrCLose ? "specDotClose" : ""}`}><FiberManualRecord aria-hidden="true" /></span>
                                                <span className={"grayText"}>{opHours.openOrCLose ? opHours.timtxt : opHours.txtBtn}</span>
                                            </p>
                                        </div>
                                        {/* עסק שלא שולח לעיר שהלקוח בחר - התגית במקום זמן המשלוח */}
                                        {notDeliveringTxt(item)
                                            ? <div className={"pgSmallTxt"}><span className={"notDelivTag"}>{notDeliveringTxt(item)}</span></div>
                                            : <div className={"pgSmallTxt inFlex"}>
                                                <div className={"theImgwrap"} >
                                                    <div className={"theImg  spaceRight"} >
                                                        <DirectionsBike aria-hidden="true" />
                                                    </div>
                                                </div>
                                                <div className={"timeTxt mediumst spaceRight spacePad grayText"}>
                                                    {(parseInt(timing) + 10) +
                                                        " - " + parseInt(timing)} דק'
                                                </div>
                                            </div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Link >
            </li >
        )
    }

    let theLst = props.mainRests || [];

    if (props.fromitem != null) {
        let filt = props.mainRests.filter(
            (it, indx) =>
                (indx >= props.fromitem) &&
                (props.toitem >= indx)
        )
        theLst = filt;
    }

    return (
        <ul className="restList">
            {


                theLst.map((item, index) => {
                    let chans = MyDateTime.resolveBusinessChannels(item, master);
                    //המיון לפי "אפשר להזמין" ולא לפי שעות הפתיחה
                    if (chans.canOrderNow) {
                        return (setOpenItem(item, index, chans))
                    }
                    else {
                        shuffClosed.push({ item, index, chans });

                    }
                })
            }

            {
                shuffClosed.map((item) => {
                    return (setOpenItem(item.item, item.index, item.chans))
                })
            }

        </ul>
    )
}

export default RestSmallBlock;


